module.exports = __webpack_public_path__ + "static/img/033 2.dae42240.jpg";